import { render } from "./AdFilterInput.vue?vue&type=template&id=977c01cc"
import script from "./AdFilterInput.vue?vue&type=script&lang=js"
export * from "./AdFilterInput.vue?vue&type=script&lang=js"
script.render = render

export default script